<template>
    <div 
        @click="$emit('scroll-to', replyMessageId)"
        class="mb-2 rounded-xl border-l-4 p-2 text-[11px] cursor-pointer transition-all hover:opacity-100 min-w-0 flex items-stretch overflow-hidden"
        :class="isOutgoing 
            ? 'bg-white/10 border-blue-400 text-white shadow-inner' 
            : 'bg-gray-50 border-blue-500 text-gray-800'"
    >
        <div class="flex-1 min-w-0 p-1">
            <div class="font-bold mb-0.5 truncate tracking-tighter uppercase text-[10px]"
                :class="isOutgoing ? 'text-blue-300' : 'text-blue-500'"
            >
                {{ replySender }}
            </div>
            <div class="truncate italic line-clamp-1 opacity-80 leading-snug flex items-center space-x-1">
                <template v-if="!replyBody && replyAttachmentType">
                    <PhotographIcon v-if="replyAttachmentType === 'photo' || replyAttachmentType === 'image'" class="h-3 w-3 inline mr-1" />
                    <VideoCameraIcon v-else-if="replyAttachmentType === 'video'" class="h-3 w-3 inline mr-1" />
                    <MicrophoneIcon v-else-if="replyAttachmentType === 'audio'" class="h-3 w-3 inline mr-1" />
                    <DocumentTextIcon v-else class="h-3 w-3 inline mr-1" />
                    <span>{{ formatAttachmentType(replyAttachmentType) }}</span>
                </template>
                <template v-else>
                    {{ replyBody }}
                </template>
            </div>
        </div>

        <!-- Attachment Preview -->
        <div v-if="replyAttachmentUrl || replyAttachmentType" class="w-12 h-auto flex-shrink-0 bg-black/5 flex items-center justify-center border-l border-white/10 ml-2">
            <template v-if="replyAttachmentType === 'photo' || replyAttachmentType === 'image'">
                <img :src="replyAttachmentUrl" class="w-full h-full object-cover" />
            </template>
            <template v-else-if="replyAttachmentType === 'video'">
                <div class="w-full h-full bg-gray-800 flex items-center justify-center">
                    <PlayIcon class="h-5 w-5 text-white/80" />
                </div>
            </template>
            <template v-else-if="replyAttachmentType === 'audio'">
                <MicrophoneIcon class="h-4 w-4 opacity-40" />
            </template>
            <template v-else>
                <DocumentTextIcon class="h-4 w-4 opacity-40" />
            </template>
        </div>
    </div>
</template>

<script>
import { 
    DocumentTextIcon, 
    PlayIcon, 
    MicrophoneIcon,
    PhotographIcon,
    VideoCameraIcon
} from "@heroicons/vue/outline";

export default {
    name: 'ChatReplyTo',
    components: { DocumentTextIcon, PlayIcon, MicrophoneIcon, PhotographIcon, VideoCameraIcon },
    props: {
        replyMessageId: { type: [Number, String], required: true },
        replySender: { type: String, required: true },
        replyBody: { type: String, required: true },
        isOutgoing: { type: Boolean, required: true },
        replyAttachmentUrl: { type: String, default: null },
        replyAttachmentType: { type: String, default: null }
    },
    methods: {
        formatAttachmentType(type) {
            if (!type) return 'Attachment';
            if (type === 'photo' || type === 'image') return 'Photo';
            if (type === 'video') return 'Video';
            if (type === 'audio') return 'Audio';
            return 'Document';
        }
    },
    emits: ['scroll-to']
};
</script>
